module.exports = __webpack_public_path__ + "static/media/bg-a.733e3d3c.jpg";